import { resource, RequestConfig } from '../helper/resource';

/**
 * 获取客户总资产
 */
export function assetUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/investor/renewal/client/asset', req, config);
}

/**
 * 查询合格投资者有效期
 */
export function expirationUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/investor/renewal/client/expiration', req, config);
}

/**
 * 是否合格私募投资者及有效期
 */
export function isPfVerifiedUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/investor/renewal/client/pf/verified', req, config);
}

/**
 * 是否合格资管投资者
 */
export function isVerifiedUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/client/verified', req, config);
}

/**
 * 私募-保存客户的选项(当天是否展示)
 */
export function dayShowUsingPOST_1(req: InvestorRenewalPf | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/pf/save/dayShow', req, config);
}

/**
 * 私募-保存客户的选项(是否展示)
 */
export function isShowUsingPOST_2(req: InvestorRenewalPf | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/pf/save/isShow', req, config);
}

/**
 * 私募-查询是否需要展示弹窗
 */
export function isPfShowUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/pf/show/tips', req, config);
}

/**
 * 保存客户的选项(当天是否展示)
 */
export function dayShowUsingPOST(req: InvestorRenewal | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/save/dayShow', req, config);
}

/**
 * 保存客户的选项(是否展示)
 */
export function isShowUsingPOST_1(req: InvestorRenewal | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/save/isShow', req, config);
}

/**
 * 查询是否需要展示弹窗
 */
export function isShowUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/investor/renewal/show/tips', req, config);
}
